// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MQD7","tabsBox":"styles_tabsBox__2aM2M","createButton":"styles_createButton__1K2cX"};